// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ZVaq","selects":"Documents_selects__3DTv0"};